<mat-drawer-container class="mat-draw-container" autosize>
  <mat-drawer #drawer class="sidenav" [opened]="true" mode="side">
    <a class="logo-container" routerLink="/dashboard">
      <img src="./assets/img/logo.png" alt="logo" />
    </a>

    <ul class="menu-items">
      <li routerLink="dashboard"><mat-icon>fact_check</mat-icon> Dashboard</li>
      <li routerLink="user"><mat-icon>perm_identity</mat-icon> User</li>
    </ul>
  </mat-drawer>

  <div class="example-sidenav-content">
    <mat-toolbar color="primary">
      <mat-toolbar-row>
        <mat-icon class="menu-icon" (click)="drawer.toggle()">menu</mat-icon>
        <span>Simple Customer-Relationship-Management</span>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="router-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</mat-drawer-container>
